function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#1b1464",
  stroke: "#1b1464",
  strokeWidth: "0.4px",
  d: "M126.828 16.979l-17.6-16.5A1.819 1.819 0 0 0 107.982 0H71.038A6.836 6.836 0 0 0 64 6.6v65.982a6.836 6.836 0 0 0 7.038 6.6h49.267a6.836 6.836 0 0 0 7.038-6.6V18.145a1.6 1.6 0 0 0-.515-1.166zm-3 55.6a3.419 3.419 0 0 1-3.519 3.3H71.038a3.419 3.419 0 0 1-3.519-3.3V6.6a3.419 3.419 0 0 1 3.519-3.3h36.215l16.571 15.529z",
  transform: "translate(.2 .2) translate(-64)"
}))))), /*#__PURE__*/React.createElement("path", {
  fill: "#d53d53",
  stroke: "#f76c60",
  strokeWidth: "0.1px",
  d: "M128 197.18v31.08a5.236 5.236 0 0 0 5.279 5.18h31.672a5.236 5.236 0 0 0 5.279-5.18v-31.08a5.236 5.236 0 0 0-5.279-5.18h-31.672a5.236 5.236 0 0 0-5.279 5.18zm12.317 32.807h-7.038a1.745 1.745 0 0 1-1.76-1.727v-6.907h8.8v8.634zm14.076 0h-10.557v-8.633h10.557zm12.317-1.727a1.745 1.745 0 0 1-1.76 1.727h-7.038v-10.36a1.742 1.742 0 0 0-1.76-1.727h-24.633v-10.36h35.191v20.72zm-8.8-32.807h7.038a1.745 1.745 0 0 1 1.76 1.727v6.907h-8.8v-8.633zm-14.076 0h10.557v8.633h-10.555zm-3.519 8.633h-8.8v-6.906a1.745 1.745 0 0 1 1.76-1.727h7.038v8.633z",
  transform: "translate(.2 .2) translate(-117.443 -164.269)"
}));

var SvgHChargeLarge = function SvgHChargeLarge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.744,
    height: 79.58,
    viewBox: "0 0 63.744 79.58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHChargeLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h-chargeLarge.76ae24c7.svg";
export { ForwardRef as ReactComponent };